// Reads the build the server CURRENTLY serves. /env.js is generated by the web container at
// start (nginx entrypoint) and served no-store, so fetching it again from a running tab tells
// whether the server has since been redeployed with a different commit. Lives in engine/api
// because it is the one place the web is allowed to fetch from (web/CLAUDE.md rule 1).

export interface ServedBuild {
  sha: string;
  deployedAt: string | null;
}

export async function fetchServedBuild(): Promise<ServedBuild | null> {
  try {
    const res = await fetch(`/env.js?t=${Date.now()}`, { cache: 'no-store', credentials: 'same-origin' });
    if (!res.ok) return null;
    const text = await res.text();
    const sha = /GIT_SHA:\s*"([^"]*)"/.exec(text)?.[1]?.trim() ?? '';
    const stamp = Number(/DEPLOY_TIMESTAMP:\s*"([^"]*)"/.exec(text)?.[1] ?? '');
    return {
      sha: sha && !sha.startsWith('$') ? sha : 'unknown',
      deployedAt: Number.isFinite(stamp) && stamp > 0 ? new Date(stamp).toISOString() : null,
    };
  } catch {
    return null;
  }
}
